import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';

// ─── Correspondance code catégorie juridique INSEE → libellé ─────────────────
const FORMES_JURIDIQUES = {
  '1000': 'EI', '2110': 'SARL', '2120': 'SARL', '2210': 'SA',
  '2220': 'SA', '2310': 'SA', '2320': 'SA', '2385': 'SA',
  '5191': 'SARL', '5192': 'SARL', '5193': 'SARL', '5202': 'SARL',
  '5306': 'SASU', '5307': 'SAS', '5308': 'SAS', '5309': 'SAS',
  '5310': 'SAS', '5370': 'SNC', '5410': 'SCS', '5485': 'EURL',
  '5498': 'EURL', '5499': 'SARL', '6317': 'Association',
  '7111': 'Collectivité', '7112': 'Collectivité', '7113': 'Collectivité',
  '7120': 'Collectivité', '7130': 'Collectivité', '7150': 'Collectivité',
  '7160': 'Collectivité', '7210': 'Collectivité', '7220': 'Collectivité',
  '7312': 'Établissement public', '7321': 'Établissement public',
  '7331': 'Établissement public', '7340': 'Établissement public',
  '7341': 'Établissement public', '7342': 'Établissement public',
  '7343': 'Établissement public', '7344': 'Établissement public',
  '7345': 'Établissement public', '7346': 'Établissement public',
  '7362': 'Établissement public', '7363': 'Établissement public',
  '7364': 'Établissement public', '7365': 'Établissement public',
  '7366': 'Établissement public',
  '9220': 'Association', '9221': 'Association',
};

function getFormeJuridique(code) {
  if (!code) return '';
  if (FORMES_JURIDIQUES[code]) return FORMES_JURIDIQUES[code];
  const prefix = String(code).substring(0, 2);
  if (prefix === '53') return 'SAS';
  if (prefix === '54') return 'SCS';
  if (prefix === '21' || prefix === '51') return 'SARL';
  if (prefix === '22' || prefix === '23') return 'SA';
  if (prefix === '10') return 'EI';
  if (prefix === '71' || prefix === '72') return 'Collectivité';
  if (prefix === '73') return 'Établissement public';
  if (prefix === '92' || prefix === '63') return 'Association';
  return 'Autre';
}

function capitalizeWords(str) {
  if (!str) return '';
  return str.toLowerCase().replace(/\b\w/g, c => c.toUpperCase());
}

// ─── Styles de la modale ──────────────────────────────────────────────────────
const S = {
  overlay: {
    position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.55)',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    zIndex: 1000,
  },
  dialog: {
    background: '#fff', borderRadius: '8px',
    width: '880px', maxWidth: '95vw', maxHeight: '90vh',
    display: 'flex', flexDirection: 'column',
    boxShadow: '0 8px 32px rgba(0,0,0,0.25)',
  },
  header: {
    display: 'flex', justifyContent: 'space-between', alignItems: 'center',
    padding: '1.25rem 1.5rem', borderBottom: '2px solid #ecf0f1',
    background: '#2c3e50', borderRadius: '8px 8px 0 0',
  },
  headerTitle: { color: '#fff', fontSize: '1.2rem', fontWeight: 600, margin: 0 },
  closeBtn: {
    background: 'none', border: 'none', color: '#fff',
    fontSize: '1.5rem', cursor: 'pointer', lineHeight: 1,
  },
  body: { padding: '1.5rem', overflowY: 'auto', flex: 1 },
  footer: {
    padding: '1rem 1.5rem', borderTop: '1px solid #ecf0f1',
    display: 'flex', justifyContent: 'flex-end', gap: '0.75rem',
    background: '#f8f9fa', borderRadius: '0 0 8px 8px',
  },
  grid2: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem 1.5rem' },
  grid3: { display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '1rem 1.5rem' },
  sectionTitle: {
    fontSize: '0.8rem', fontWeight: 700, textTransform: 'uppercase',
    letterSpacing: '0.08em', color: '#7f8c8d',
    margin: '1.25rem 0 0.75rem', paddingBottom: '0.35rem',
    borderBottom: '1px solid #ecf0f1',
  },
  label: {
    display: 'block', marginBottom: '0.3rem',
    fontSize: '0.875rem', fontWeight: 500, color: '#2c3e50',
  },
  required: { color: '#e74c3c', marginLeft: '2px' },
  input: {
    width: '100%', padding: '0.6rem 0.75rem',
    border: '1px solid #ddd', borderRadius: '4px',
    fontSize: '0.9rem', boxSizing: 'border-box',
  },
  inputFilled: {
    width: '100%', padding: '0.6rem 0.75rem',
    border: '1px solid #27ae60', borderRadius: '4px',
    fontSize: '0.9rem', boxSizing: 'border-box',
    background: '#f0fff4',
  },
  select: {
    width: '100%', padding: '0.6rem 0.75rem',
    border: '1px solid #ddd', borderRadius: '4px',
    fontSize: '0.9rem', background: '#fff', boxSizing: 'border-box',
  },
  textarea: {
    width: '100%', padding: '0.6rem 0.75rem',
    border: '1px solid #ddd', borderRadius: '4px',
    fontSize: '0.9rem', resize: 'vertical', minHeight: '70px', boxSizing: 'border-box',
  },
  textareaFilled: {
    width: '100%', padding: '0.6rem 0.75rem',
    border: '1px solid #27ae60', borderRadius: '4px',
    fontSize: '0.9rem', resize: 'vertical', minHeight: '70px', boxSizing: 'border-box',
    background: '#f0fff4',
  },
  errorBanner: {
    background: '#f8d7da', color: '#721c24',
    padding: '0.75rem 1rem', borderRadius: '4px',
    marginBottom: '1rem', fontSize: '0.9rem',
    borderLeft: '4px solid #e74c3c',
  },
  siretBanner: {
    display: 'flex', alignItems: 'center', gap: '0.5rem',
    padding: '0.6rem 1rem', borderRadius: '4px',
    marginBottom: '0.75rem', fontSize: '0.875rem',
  },
  siretRow: { display: 'flex', gap: '0.5rem', alignItems: 'flex-end' },
  siretInputWrap: { flex: 1 },
  lookupBtn: {
    padding: '0.6rem 1rem', background: '#3498db', color: '#fff',
    border: 'none', borderRadius: '4px', cursor: 'pointer',
    fontSize: '0.875rem', fontWeight: 600, whiteSpace: 'nowrap',
    height: '38px', display: 'flex', alignItems: 'center', gap: '0.35rem',
  },
  lookupBtnDisabled: {
    padding: '0.6rem 1rem', background: '#95a5a6', color: '#fff',
    border: 'none', borderRadius: '4px', cursor: 'not-allowed',
    fontSize: '0.875rem', fontWeight: 600, whiteSpace: 'nowrap',
    height: '38px', display: 'flex', alignItems: 'center', gap: '0.35rem',
  },
  spinner: {
    display: 'inline-block', width: '14px', height: '14px',
    border: '2px solid rgba(255,255,255,0.4)',
    borderTopColor: '#fff', borderRadius: '50%',
    animation: 'spin 0.7s linear infinite',
  },
};

function Field({ label, required, children }) {
  return (
    <div>
      <label style={S.label}>
        {label}
        {required && <span style={S.required}>*</span>}
      </label>
      {children}
    </div>
  );
}

const EMPTY_FORM = {
  nom: '', adresse: '', code_postal: '',
  ville: '', forme_juridique: '', siret: '', representant: '',
  titre_representant: '',
};

// ─── Composant principal ──────────────────────────────────────────────────────
function ClientList() {
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(true);

  // Modale
  const [showModal, setShowModal] = useState(false);
  const [form, setForm] = useState(EMPTY_FORM);
  const [saving, setSaving] = useState(false);
  const [formError, setFormError] = useState('');

  // SIRET lookup
  const [siretLoading, setSiretLoading] = useState(false);
  const [siretStatus, setSiretStatus] = useState(null);
  const [siretMsg, setSiretMsg] = useState('');
  const [autoFilled, setAutoFilled] = useState(false);
  const debounceRef = useRef(null);

  useEffect(() => { fetchClients(); }, []);

  const fetchClients = async () => {
    try {
      const r = await axios.get('/api/clients');
      setClients(r.data);
    } catch (e) { console.error(e); }
    finally { setLoading(false); }
  };

  const openModal = () => {
    setForm(EMPTY_FORM);
    setFormError('');
    setSiretStatus(null);
    setSiretMsg('');
    setAutoFilled(false);
    setShowModal(true);
  };

  const closeModal = () => { if (!saving) setShowModal(false); };

  // ── Recherche SIRET via API ─────────────────────────────────────────────────
  const lookupSiret = async (siret) => {
    const clean = String(siret).replace(/\s/g, '');
    if (clean.length !== 14) {
      setSiretStatus('error');
      setSiretMsg('Le SIRET doit comporter exactement 14 chiffres.');
      return;
    }

    setSiretLoading(true);
    setSiretStatus(null);
    setSiretMsg('');

    try {
      const url = 'https://recherche-entreprises.api.gouv.fr/search?q=' + clean + '&page=1&per_page=1';
      const response = await fetch(url);

      if (!response.ok) throw new Error('HTTP ' + response.status);
      const data = await response.json();

      if (!data.results || data.results.length === 0) {
        setSiretStatus('error');
        setSiretMsg('Aucune entreprise trouvée pour ce SIRET.');
        return;
      }

      const entreprise = data.results[0];
      let etablissement = null;

      if (entreprise.matching_etablissements && entreprise.matching_etablissements.length > 0) {
        etablissement = entreprise.matching_etablissements.find(
          e => e.siret === clean
        ) || entreprise.matching_etablissements[0];
      }

      const nom = entreprise.nom_complet || entreprise.nom_raison_sociale || '';
      const formeCode = entreprise.nature_juridique || '';
      const forme = getFormeJuridique(formeCode);

      let adresse = '';
      let code_postal = '';
      let ville = '';

      if (etablissement) {
        const num = etablissement.numero_voie || '';
        const type = etablissement.type_voie || '';
        const libelle = etablissement.libelle_voie || '';
        const compl = etablissement.complement_adresse || '';

        adresse = [compl, (num + ' ' + type + ' ' + libelle).trim()]
          .filter(Boolean).map(s => s.trim()).filter(Boolean).join(', ');

        code_postal = etablissement.code_postal || '';
        ville = capitalizeWords(etablissement.libelle_commune || '');
      }

      setForm(prev => ({
        ...prev,
        nom: nom || prev.nom,
        adresse: adresse || prev.adresse,
        code_postal: code_postal || prev.code_postal,
        ville: ville || prev.ville,
        forme_juridique: forme || prev.forme_juridique,
      }));

      setAutoFilled(true);
      setSiretStatus('ok');
      setSiretMsg('✓ ' + nom + ' — données pré-remplies depuis le Registre National des Entreprises');
    } catch (err) {
      console.error('Erreur lookup SIRET:', err);
      setSiretStatus('error');
      setSiretMsg("Impossible de contacter l'API entreprises. Vérifiez votre connexion ou renseignez les champs manuellement.");
    } finally {
      setSiretLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));

    if (name === 'siret') {
      setAutoFilled(false);
      setSiretStatus(null);
      setSiretMsg('');
      const clean = value.replace(/\s/g, '');
      if (clean.length === 14) {
        clearTimeout(debounceRef.current);
        debounceRef.current = setTimeout(() => lookupSiret(clean), 400);
      }
    }
  };

  const handleSubmit = async () => {
    setFormError('');
    if (!form.nom.trim()) { setFormError('Le nom est obligatoire.'); return; }

    setSaving(true);
    try {
      await axios.post('/api/clients', form);
      await fetchClients();
      setShowModal(false);
    } catch (err) {
      setFormError(err.response?.data?.details || err.response?.data?.error || 'Erreur lors de la création.');
    } finally {
      setSaving(false);
    }
  };

  const handleDelete = async (codification) => {
    if (window.confirm('Êtes-vous sûr de vouloir supprimer ce client ?')) {
      try {
        await axios.delete('/api/clients/' + codification);
        fetchClients();
      } catch { alert('Erreur lors de la suppression'); }
    }
  };

  const inputStyle = (field) => autoFilled && form[field] ? S.inputFilled : S.input;
  const taStyle = (field) => autoFilled && form[field] ? S.textareaFilled : S.textarea;

  if (loading) return <div className="loading">Chargement...</div>;

  return (
    <div>
      <style>{`
        @keyframes spin { to { transform: rotate(360deg); } }
      `}</style>

      <div className="card">
        <div className="card-header">
          <h1 className="card-title">Clients</h1>
          <button className="btn btn-primary" onClick={openModal}>
            + Nouveau client
          </button>
        </div>

        <table>
          <thead>
            <tr>
              <th>Codification</th>
              <th>Nom</th>
              <th>Ville</th>
              <th>Forme juridique</th>
              <th>SIRET</th>
              <th>Représentant</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {clients.length === 0 ? (
              <tr><td colSpan="7" style={{ textAlign: 'center', padding: '2rem' }}>
                Aucun client trouvé
              </td></tr>
            ) : clients.map(c => (
              <tr key={c.codification}>
                <td><strong>{c.codification}</strong></td>
                <td>{c.nom}</td>
                <td>{c.ville || '—'}</td>
                <td>{c.forme_juridique || '—'}</td>
                <td style={{ fontFamily: 'monospace', fontSize: '0.85rem' }}>{c.siret || '—'}</td>
                <td>{c.representant || '—'}</td>
                <td>
                  <div className="actions">
                    <Link to={'/clients/' + c.codification} className="btn btn-primary">Détails</Link>
                    <button onClick={() => handleDelete(c.codification)} className="btn btn-danger">Supprimer</button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* ── Modale création ── */}
      {showModal && (
        <div style={S.overlay} onClick={closeModal}>
          <div style={S.dialog} onClick={e => e.stopPropagation()}>

            <div style={S.header}>
              <h2 style={S.headerTitle}>Nouveau client</h2>
              <button style={S.closeBtn} onClick={closeModal} title="Fermer">×</button>
            </div>

            <div style={S.body}>
              {formError && <div style={S.errorBanner}>{formError}</div>}

              {/* SIRET */}
              <div style={S.sectionTitle}>Recherche automatique par SIRET</div>

              <div style={S.siretRow}>
                <div style={S.siretInputWrap}>
                  <Field label="SIRET" required>
                    <input
                      style={siretStatus === 'ok' ? S.inputFilled : S.input}
                      name="siret"
                      value={form.siret}
                      onChange={handleChange}
                      placeholder="Saisir les 14 chiffres du SIRET…"
                      maxLength={14}
                    />
                  </Field>
                </div>
                <button
                  style={siretLoading ? S.lookupBtnDisabled : S.lookupBtn}
                  onClick={() => lookupSiret(form.siret)}
                  disabled={siretLoading}
                  title="Rechercher les informations de l'entreprise"
                >
                  {siretLoading
                    ? <><span style={S.spinner} /> Recherche…</>
                    : <>🔍 Rechercher</>
                  }
                </button>
              </div>

              {siretMsg && (
                <div style={{
                  ...S.siretBanner,
                  background: siretStatus === 'ok' ? '#d4edda' : '#fff3cd',
                  color: siretStatus === 'ok' ? '#155724' : '#856404',
                  border: '1px solid ' + (siretStatus === 'ok' ? '#c3e6cb' : '#ffeeba'),
                }}>
                  {siretMsg}
                </div>
              )}

              {autoFilled && (
                <div style={{
                  fontSize: '0.78rem', color: '#27ae60',
                  marginBottom: '0.75rem',
                  display: 'flex', alignItems: 'center', gap: '0.4rem',
                }}>
                  <span>🟢</span>
                  <span>Les champs surlignés en vert ont été remplis automatiquement — vous pouvez les modifier si nécessaire.</span>
                </div>
              )}

              {/* Identification */}
              <div style={S.sectionTitle}>Identification</div>
              <Field label="Nom / Raison sociale" required>
                <input style={inputStyle('nom')} name="nom"
                  value={form.nom} onChange={handleChange}
                  placeholder="Raison sociale" />
              </Field>

              {/* Coordonnées */}
              <div style={S.sectionTitle}>Coordonnées</div>
              <div style={{ marginBottom: '1rem' }}>
                <Field label="Adresse">
                  <textarea style={taStyle('adresse')} name="adresse"
                    value={form.adresse} onChange={handleChange}
                    placeholder="Numéro, rue…" rows={2} />
                </Field>
              </div>
              <div style={S.grid3}>
                <Field label="Code postal">
                  <input style={inputStyle('code_postal')} name="code_postal"
                    value={form.code_postal} onChange={handleChange}
                    placeholder="75000" maxLength={10} />
                </Field>
                <Field label="Ville">
                  <input style={inputStyle('ville')} name="ville"
                    value={form.ville} onChange={handleChange}
                    placeholder="Paris" />
                </Field>
                <Field label="Forme juridique">
                  <select
                    style={autoFilled && form.forme_juridique
                      ? { ...S.select, border: '1px solid #27ae60', background: '#f0fff4' }
                      : S.select
                    }
                    name="forme_juridique" value={form.forme_juridique} onChange={handleChange}>
                    <option value="">— Sélectionner —</option>
                    <option value="Collectivité">Collectivité</option>
                    <option value="Établissement public">Établissement public</option>
                    <option value="SARL">SARL</option>
                    <option value="SAS">SAS</option>
                    <option value="SA">SA</option>
                    <option value="SASU">SASU</option>
                    <option value="EURL">EURL</option>
                    <option value="SNC">SNC</option>
                    <option value="EI">EI / Auto-entrepreneur</option>
                    <option value="Association">Association</option>
                    <option value="Autre">Autre</option>
                  </select>
                </Field>
              </div>

              {/* Représentant */}
              <div style={S.sectionTitle}>Représentant</div>
              <div style={S.grid2}>
                <Field label="Nom du représentant">
                  <input style={S.input} name="representant"
                    value={form.representant} onChange={handleChange}
                    placeholder="Prénom Nom" />
                </Field>
                <Field label="Titre du représentant">
                  <input style={S.input} name="titre_representant"
                    value={form.titre_representant} onChange={handleChange}
                    placeholder="Ex : Maire, Président, Directeur…" />
                </Field>
              </div>
            </div>

            <div style={S.footer}>
              <button className="btn btn-secondary" onClick={closeModal} disabled={saving}>
                Annuler
              </button>
              <button className="btn btn-primary" onClick={handleSubmit} disabled={saving}>
                {saving ? 'Enregistrement…' : 'Créer le client'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default ClientList;
